
import { mapGetters } from "vuex"
import EnergyVote from "@/services/EnergyVote.js"
import EnergyVoteLayout from "@soenergy/frontend-library/src/components/EnergyVoteLayout"
import PersistentStoreService from "@soenergy/frontend-library/src/services/PersistentStoreService"

export default {
  name: `EnergyVote`,
  components: {
    EnergyVoteLayout
  },
  props: {
    theme: {
      required: true,
      type: String
    },
    title: {
      required: true,
      type: Array
    },
    description: {
      type: Array,
      default: () => []
    },
    selectionText: {
      type: Array,
      default: () => []
    },
    cards: {
      required: true,
      type: Array
    },
    button: {
      type: Array,
      default: () => []
    },
    disclaimer: {
      type: Array,
      default: () => []
    },
    voteTracking: {
      type: Array,
      default: null
    },
    isCardOrderRandom: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      energyVote: null,
      voteEnabled: false
    }
  },
  computed: {
    ...mapGetters("userStatus", ["isLoggedIn"])
  },
  watch: {
    isLoggedIn(update) {
      this.getEnergyVote()
    }
  },
  mounted() {
    this.getEnergyVote()
  },
  methods: {
    handleEnableVote(value) {
      this.voteEnabled = value
    },
    handleEnergyVote(value) {
      const trackingEnabled =
        this.$analytics && this.voteTracking && this.voteTracking.length
      if (trackingEnabled) {
        this.$analytics.sendEvent({
          ...this.voteTracking[0],
          gaLabel: value,
          mixpanelEventProperties: {
            source: value
          }
        })
      }
      if (this.isLoggedIn) {
        EnergyVote.sendVote(value, {
          useLegacyAuthentication: false
        })
          .then(response => {
            this.voteEnabled = false
            this.getEnergyVote()
            PersistentStoreService.ignoreCache()
          })
          .catch(error => {
            console.log("There was an error", error)
          })
      } else {
        // send to login
        this.$router.push({
          path: "/energy-source-vote/",
          query: { vote: value }
        })
      }
    },
    getEnergyVote() {
      if (this.isLoggedIn) {
        EnergyVote.getVote({
          useLegacyAuthentication: false
        })
          .then(response => {
            if (response.data) {
              this.energyVote = response.data.current_energy_source_vote
            }
          })
          .catch(error => {
            console.log("There was an error", error)
          })
      }
    }
  }
}
